<ng-container *transloco="let t">
  <!-- Loading spinner -->
  <div class="draft-loading" *ngIf="loading">
    <nz-spin nzSimple nzSize="large"></nz-spin>
  </div>

  <nz-page-header
    class="page-details header"
    [nzBackIcon]="backBtnTemplate"
    *ngIf="!loading && entity"
  >
    <nz-page-header-title>{{ title }}</nz-page-header-title>
    <nz-page-header-extra>
      <authority-labs-draft-toolbar
        [autoSaveStatus]="autoSaveStatus"
        [readonly]="readonly"
        [canUndo]="draftState.canUndo"
        [canFinish]="canFinishDraft"
        [canReopen]="canReopen"
        [draftClosed]="draftClosed"
        [hasInkData]="hasInkData"
        [recognizing]="recognizing"
        (undoClick)="undo()"
        (finishClick)="finishDraft()"
        (reopenClick)="reopenDraft()"
      ></authority-labs-draft-toolbar>
    </nz-page-header-extra>
    <nz-page-header-content>
      <main class="input">
        <!-- Stacked form layout -->
        <div class="draft-container">
          <div class="draft-content">
            <!-- General section -->
            <section class="draft-section">
              <ng-container [ngTemplateOutlet]="generalTpl"></ng-container>
            </section>

            <!-- Inspection type sections (stacked, not tabbed) -->
            <ng-container *ngFor="let section of sectionItems">
              <section class="draft-section" *ngIf="section.template">
                <ng-container
                  [ngTemplateOutlet]="section.template"
                ></ng-container>
              </section>
            </ng-container>

            <!-- Summary section -->
            <section class="draft-section">
              <ng-container [ngTemplateOutlet]="summeryTpl"></ng-container>
            </section>
          </div>
        </div>
      </main>
    </nz-page-header-content>
  </nz-page-header>

  <!-- ============================================ -->
  <!-- Templates (mirrored from inspection-details) -->
  <!-- ============================================ -->

  <ng-template #backBtnTemplate>
    <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
  </ng-template>

  <ng-template #generalTpl>
    <div class="form">
      <h3 class="main-title">{{ t('inspection.sections.general') }}</h3>
      <div class="list">
        <mat-form-field floatLabel="always">
          <mat-label>{{
            t('inspection.fields.general:inspectionDate')
          }}</mat-label>
          <input
            matInput
            class="text"
            name="inspectionDate"
            [matDatepicker]="picker"
            [(ngModel)]="entity.inspectionDate"
            (ngModelChange)="onFormFieldChange()"
            (click)="picker.open()"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #picker></mat-datepicker>

        <mat-form-field floatLabel="always">
          <mat-label>{{
            t('inspection.fields.general:representativeName')
          }}</mat-label>
          <input
            matInput
            drawableField="general:representativeName"
            [drawableFieldTitle]="
              t('inspection.fields.general:representativeName')
            "
            [drawableFieldReadonly]="readonly"
            name="representativeName"
            [(ngModel)]="entity.representativeName"
            (ngModelChange)="onFormFieldChange()"
          />
        </mat-form-field>

        <mat-form-field floatLabel="always">
          <mat-label>{{
            t('inspection.fields.general:inspectionType')
          }}</mat-label>
          <input
            matInput
            drawableField="general:inspectionType"
            [drawableFieldTitle]="t('inspection.fields.general:inspectionType')"
            [drawableFieldReadonly]="readonly"
            name="inspectionType"
            [ngModel]="entity.inspectionType"
            readonly
          />
        </mat-form-field>

        <mat-form-field floatLabel="always">
          <mat-label>{{ t('inspection.fields.general:standard') }}</mat-label>
          <input
            matInput
            drawableField="general:standard"
            [drawableFieldTitle]="t('inspection.fields.general:standard')"
            [drawableFieldReadonly]="readonly"
            name="standard"
            [ngModel]="entity.standard"
            readonly
          />
        </mat-form-field>

        <mat-form-field floatLabel="always">
          <mat-label>{{
            t('inspection.fields.general:standardExtraText')
          }}</mat-label>
          <textarea
            matInput
            drawableField="general:standardExtraText"
            [drawableFieldTitle]="
              t('inspection.fields.general:standardExtraText')
            "
            [drawableFieldReadonly]="readonly"
            name="standardExtraText"
            cdkTextareaAutosize
            [(ngModel)]="entity.standardExtraText"
            (ngModelChange)="onFormFieldChange()"
          ></textarea>
        </mat-form-field>

        <mat-form-field floatLabel="always">
          <mat-label>{{
            t('inspection.fields.general:inspectionCount')
          }}</mat-label>
          <textarea
            matInput
            drawableField="general:inspectionCount"
            [drawableFieldTitle]="
              t('inspection.fields.general:inspectionCount')
            "
            [drawableFieldReadonly]="readonly"
            name="inspectionCount"
            cdkTextareaAutosize
            [(ngModel)]="entity.inspectionCount"
            (ngModelChange)="onFormFieldChange()"
          ></textarea>
        </mat-form-field>

        <div class="disclaimer">
          <h2>{{ t('inspection.sections.conflictOfInterest') }}</h2>
          <ul>
            <li>
              <label>{{
                t('inspection.fields.disclaimer:conflictQuestion')
              }}</label>
              <mat-radio-group
                [(ngModel)]="entity.disclaimer.isThereConflictOfInterest"
                (ngModelChange)="onFormFieldChange()"
                [disabled]="readonly || printPreview"
              >
                <mat-radio-button [value]="true" color="warn">{{
                  t('yes')
                }}</mat-radio-button>
                <mat-radio-button [value]="false">{{
                  t('no')
                }}</mat-radio-button>
              </mat-radio-group>
            </li>
            <li>
              <label>{{
                t('inspection.fields.disclaimer:biasQuestion')
              }}</label>
              <mat-radio-group
                [(ngModel)]="entity.disclaimer.isThereReasonForBias"
                (ngModelChange)="onFormFieldChange()"
                [disabled]="readonly || printPreview"
              >
                <mat-radio-button [value]="true" color="warn">{{
                  t('yes')
                }}</mat-radio-button>
                <mat-radio-button [value]="false">{{
                  t('no')
                }}</mat-radio-button>
                <mat-form-field
                  *ngIf="entity.disclaimer.isThereReasonForBias"
                  class="disclaimer-note"
                >
                  <textarea
                    matInput
                    [(ngModel)]="entity.disclaimer.note"
                    (ngModelChange)="onFormFieldChange()"
                    rows="4"
                    [placeholder]="t('inspection.fields.disclaimer:addNote')"
                    [readonly]="readonly || printPreview"
                    drawableField="general:disclaimerNote"
                    [drawableFieldTitle]="
                      t('inspection.fields.disclaimer:addNote')
                    "
                    [drawableFieldReadonly]="readonly"
                  ></textarea>
                </mat-form-field>
              </mat-radio-group>
            </li>
            <li>
              <p style="margin-bottom: 0">
                {{ t('inspection.fields.disclaimer:paragraph1') }}
              </p>
              <p>
                {{ t('inspection.fields.disclaimer:paragraph2') }}
              </p>
              <p>
                {{ t('inspection.fields.disclaimer:paragraph3') }}
              </p>
            </li>
          </ul>

          <div class="assignee">
            <p>
              <span>{{ t('inspection.fields.general:inspectorName') }}</span
              ><span class="value">{{
                entity.order?.assignee | username
              }}</span>
            </p>
            <p style="margin-right: 100px">
              <span>{{
                t('inspection.fields.general:inspectionDatePerformed')
              }}</span>
              <span class="value">{{ entity.inspectionDate | date }}</span>
            </p>
          </div>
          <p>
            <span>{{
              t('inspection.fields.general:disclaimerSignature')
            }}</span>
            <span class="value signature">
              <mat-form-field>
                <textarea
                  matInput
                  drawableField="general:disclaimerSignature"
                  [drawableFieldTitle]="
                    t('inspection.fields.general:disclaimerSignature')
                  "
                  [drawableFieldReadonly]="readonly"
                  name="disclaimerSignature"
                  cdkTextareaAutosize
                ></textarea>
              </mat-form-field>
            </span>
          </p>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Inspection Design -->
  <ng-template #inspectionDesignTpl>
    <div class="form">
      <h3 class="main-title">{{ entity.inspectionDesign?.title }}</h3>
      <authority-labs-plans
        [planningDetails]="entity.inspectionDesign.planningDetails"
        [orderDirectory]="entity.order?.sharePoint"
        [orderId]="entity.orderId"
        [printPreview]="false"
        [readonly]="readonly"
        inkSectionKey="design"
        (dataChange)="onDataChange()"
      ></authority-labs-plans>
      <authority-labs-sprinkler-system-design-inspection
        [data]="entity.inspectionDesign.sprinklerSystemDesign"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-sprinkler-system-design-inspection>
      <authority-labs-pump-room-design-inspection
        [data]="entity.inspectionDesign.pumpRoomDesign"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-pump-room-design-inspection>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionDesign?.summaryNotes"
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionDesign.title"
        (dataChange)="onSummaryNotesChange($event, entity.inspectionDesign)"
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Inspection Installation -->
  <ng-template #inspectionInstallationTpl>
    <div class="form">
      <h3 class="main-title">{{ entity.inspectionInstallation?.title }}</h3>
      <mat-form-field floatLabel="always" appearance="fill">
        <mat-label>{{
          t('inspection.fields.installation:companion')
        }}</mat-label>
        <input
          type="text"
          matInput
          drawableField="installation:companion"
          [drawableFieldTitle]="t('inspection.fields.installation:companion')"
          [drawableFieldReadonly]="readonly"
          [placeholder]="
            t('inspection.fields.installation:companionPlaceholder')
          "
          [(ngModel)]="entity.inspectionInstallation.companion"
          (ngModelChange)="onFormFieldChange()"
        />
      </mat-form-field>
      <authority-labs-sprinkler-system-installation-inspection
        [data]="entity.inspectionInstallation.sprinklerSystemInstallation"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-sprinkler-system-installation-inspection>
      <authority-labs-pump-room-installation-inspection
        [data]="entity.inspectionInstallation.pumpRoomInstallation"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-pump-room-installation-inspection>
      <authority-labs-water-network-characterization-inspection
        [waterNetworkData]="
          entity.inspectionInstallation.waterNetworkCharacterization
        "
        [systemFlow]="entity.waterFlowPressure?.flowRate"
        [systemDemand]="entity.waterFlowPressure?.pressure"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-water-network-characterization-inspection>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionInstallation?.summaryNotes"
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionInstallation.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionInstallation)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Water Network Characterization -->
  <ng-template #inspectionWaterNetworkCharacterizationTpl>
    <div class="form">
      <h3 class="main-title">
        {{ entity.inspectionWaterNetworkCharacterization?.title }}
      </h3>
      <authority-labs-water-network-characterization-inspection
        [waterNetworkData]="entity.inspectionWaterNetworkCharacterization"
        [systemFlow]="entity.waterFlowPressure?.flowRate"
        [systemDemand]="entity.waterFlowPressure?.pressure"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-water-network-characterization-inspection>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionWaterNetworkCharacterization?.summaryNotes"
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionWaterNetworkCharacterization.title"
        (dataChange)="
          onSummaryNotesChange(
            $event,
            entity.inspectionWaterNetworkCharacterization
          )
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Gas Extinguishing System -->
  <ng-template #inspectionGasExtinguishingSystemTpl>
    <div class="form">
      <h3 class="main-title">
        {{ entity.inspectionGasExtinguishingSystem?.title }}
      </h3>
      <authority-labs-plans
        [planningDetails]="
          entity.inspectionGasExtinguishingSystem.planningDetails
        "
        [orderDirectory]="entity.order?.sharePoint"
        [orderId]="entity.orderId"
        [printPreview]="false"
        [readonly]="readonly"
        inkSectionKey="gasExtinguishing"
        (dataChange)="onDataChange()"
      ></authority-labs-plans>
      <authority-labs-gas-extinguishing-system
        [data]="
          entity.inspectionGasExtinguishingSystem.gasExtinguishingSystemDesign
        "
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-gas-extinguishing-system>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionGasExtinguishingSystem?.summaryNotes"
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionGasExtinguishingSystem.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionGasExtinguishingSystem)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Fire Taps -->
  <ng-template #inspectionFireTapsTpl>
    <div class="form">
      <h3 class="main-title">{{ entity.inspectionFireTaps?.title }}</h3>
      <authority-labs-fire-taps
        [data]="entity.inspectionFireTaps"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-fire-taps>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionFireTaps?.summaryNotes"
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionFireTaps.title"
        (dataChange)="onSummaryNotesChange($event, entity.inspectionFireTaps)"
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Fire Extinguishers -->
  <ng-template #inspectionFireExtinguishersTpl>
    <div class="form">
      <h3 class="main-title">
        {{ entity.inspectionFireExtinguishers?.title }}
      </h3>
      <authority-labs-fire-extinguishers
        [data]="entity.inspectionFireExtinguishers"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-fire-extinguishers>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionFireExtinguishers?.summaryNotes"
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionFireExtinguishers.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionFireExtinguishers)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Aerosol Shutdown -->
  <ng-template #inspectionAerosolShutdownTpl>
    <div class="form">
      <h3 class="main-title">{{ entity.inspectionAerosolShutdown?.title }}</h3>
      <authority-labs-plans
        [planningDetails]="entity.inspectionAerosolShutdown.planningDetails"
        [orderDirectory]="entity.order?.sharePoint"
        [orderId]="entity.orderId"
        [printPreview]="false"
        [readonly]="readonly"
        inkSectionKey="aerosolShutdown"
        (dataChange)="onDataChange()"
      ></authority-labs-plans>
      <authority-labs-aerosol-shutdown
        [data]="entity.inspectionAerosolShutdown.aerosolShutdownDesign"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-aerosol-shutdown>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionAerosolShutdown?.summaryNotes"
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionAerosolShutdown.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionAerosolShutdown)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Fire Alarm System -->
  <ng-template #inspectionFireAlarmSystemTpl>
    <div class="form">
      <h3 class="main-title">{{ entity.inspectionFireAlarmSystem?.title }}</h3>
      <authority-labs-plans
        [planningDetails]="entity.inspectionFireAlarmSystem.planningDetails"
        [orderDirectory]="entity.order?.sharePoint"
        [orderId]="entity.orderId"
        [printPreview]="false"
        [readonly]="readonly"
        inkSectionKey="fireAlarmSystem"
        (dataChange)="onDataChange()"
      ></authority-labs-plans>
      <authority-labs-fire-alarm-system
        [data]="entity.inspectionFireAlarmSystem.fireAlarmSystemDesign"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-fire-alarm-system>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionFireAlarmSystem?.summaryNotes"
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionFireAlarmSystem.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionFireAlarmSystem)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Air Conditioning and Ventilation Systems -->
  <ng-template #inspectionAirConditioningAndVentilationSystemsTpl>
    <div class="form">
      <h3 class="main-title">
        {{ entity.inspectionAirConditioningAndVentilationSystems?.title }}
      </h3>
      <authority-labs-air-conditioning-and-ventilation-systems
        [data]="entity.inspectionAirConditioningAndVentilationSystems"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-air-conditioning-and-ventilation-systems>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="
          entity?.inspectionAirConditioningAndVentilationSystems?.summaryNotes
        "
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionAirConditioningAndVentilationSystems.title"
        (dataChange)="
          onSummaryNotesChange(
            $event,
            entity.inspectionAirConditioningAndVentilationSystems
          )
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Ventilation System and Fire Protection -->
  <ng-template #inspectionVentilationSystemAndFireProtectionTpl>
    <div class="form">
      <h3 class="main-title">
        {{ entity.inspectionVentilationSystemAndFireProtection?.title }}
      </h3>
      <authority-labs-ventilation-system-and-fire-protection-in-commercial-cooking-systems
        [data]="entity.inspectionVentilationSystemAndFireProtection"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-ventilation-system-and-fire-protection-in-commercial-cooking-systems>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="
          entity?.inspectionVentilationSystemAndFireProtection?.summaryNotes
        "
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionVentilationSystemAndFireProtection.title"
        (dataChange)="
          onSummaryNotesChange(
            $event,
            entity.inspectionVentilationSystemAndFireProtection
          )
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Pressure System in Stairwells -->
  <ng-template #inspectionPressureSystemInStairwellsCompatibilityCheckTpl>
    <div class="form">
      <h3 class="main-title">
        {{
          entity.inspectionPressureSystemInStairwellsCompatibilityCheck?.title
        }}
      </h3>
      <authority-labs-pressure-system-in-stairwells-compatibility-check
        [data]="entity.inspectionPressureSystemInStairwellsCompatibilityCheck"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-pressure-system-in-stairwells-compatibility-check>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="
          entity?.inspectionPressureSystemInStairwellsCompatibilityCheck
            ?.summaryNotes
        "
        [printPreview]="false"
        [readonly]="readonly"
        [type]="
          entity.inspectionPressureSystemInStairwellsCompatibilityCheck.title
        "
        (dataChange)="
          onSummaryNotesChange(
            $event,
            entity.inspectionPressureSystemInStairwellsCompatibilityCheck
          )
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Integration -->
  <ng-template #inspectionIntegrationTpl>
    <div class="form">
      <h3 class="main-title">{{ entity.inspectionIntegration?.title }}</h3>
      <authority-labs-integration
        [data]="entity.inspectionIntegration"
        [orderDirectory]="entity.order?.sharePoint"
        [orderId]="entity.orderId"
        [printPreview]="false"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-integration>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionIntegration?.summaryNotes"
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionIntegration.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionIntegration)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <!-- Summary -->
  <ng-template #summeryTpl>
    <div class="form">
      <h3 class="main-title">{{ t('inspection.sections.summary') }}</h3>

      <mat-form-field floatLabel="always">
        <mat-label>{{ t('conclusion') }}</mat-label>
        <input
          matInput
          class="text"
          name="conclusion"
          [ngModel]="entity.order?.conclusion"
          readonly
        />
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>{{ t('assignee') }}</mat-label>
        <input
          matInput
          name="assignee"
          [ngModel]="entity.order?.assignee | username"
          readonly
        />
      </mat-form-field>

      <h3 class="main-title">
        {{ t('inspection.sections.summaryCertificateNotes') }}
      </h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.summaryNotes"
        [printPreview]="false"
        [readonly]="readonly"
        [type]="entity.inspectionType + '_הערות סיכום לתעודה'"
        (dataChange)="onSummaryNotesChange($event, entity)"
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>
</ng-container>
